export const formatToLocalDate = stringDate => {
  if (stringDate) {
    stringDate = stringDate.replace(" ", "T");
    let date = new Date(stringDate + "Z");
    let items = date.toString().split(" ");
    let out = items[1] + "-" + items[2] + "-" + items[3] + " " + items[4];
    return out.substring(0, out.length - 3);
  } else {
    return null;
  }
};

export const formatToLocalDateWithoutTimestamp = date => {
  if (date) {
    const dateAsUTCISOString = new Date(date + " UTC").toISOString();
    return new Date(dateAsUTCISOString).toLocaleDateString(undefined, {
      month: "short",
      day: "2-digit"
    });
  }

  return null;
};
